/* eslint-disable unicorn/prefer-code-point */
/* eslint-disable unicorn/no-null */

import { FormInstance } from 'antd';
import { type NamePath } from 'antd/es/form/interface';
import axios from 'axios';

import { POSTAL_CODE_PATTERN } from '@/constants/regex.constants';

const messageZipcodeNotfound = '無効な郵便番号です。もう一度ご確認ください。';

interface Address {
  prefecture: string;
  city: string;
  area: string;
  street: string;
}
interface AddressData {
  addresses: {
    ja: Record<string, string>;
  }[];
}
type Callback = (address: Address | null) => void;
type Cache = Record<string, AddressData>;

const JSON_DATA_URL = 'https://jp-postal-code-api.ttskch.com/api/v1';
const CACHE: Cache = {};

const getAddressByPostalCode = function (zipCode: string, callback: Callback) {
  // 郵便番号を数字のみ7桁取り出す
  const vZip = zipCode;
  if (!vZip) return;

  // extract number only
  let nZip = '';
  for (let index = 0; index < vZip.length; index++) {
    const chr = vZip.charCodeAt(index);
    if (chr < 48) continue;
    if (chr > 57) continue;
    nZip += vZip.charAt(index);
  }
  if (nZip.length < 7) return;

  // fetch from cache data using upper 7 digit
  const addressRecord = CACHE[nZip];
  if (addressRecord) return parse(addressRecord, callback);

  fetchRemote(nZip, callback);
};

const parse = function (addressRecord: AddressData, callback: Callback) {
  const addresses = addressRecord?.addresses?.[0]?.ja;
  if (!addresses) {
    callback(null);
    return;
  }
  const city = addresses.address1;
  const area = addresses.address2;
  const street = addresses.address3;
  const prefecture = addresses.prefecture;
  callback({ prefecture, city, area, street });
};

const fetchRemote = async function (nZip: string, callback: Callback) {
  try {
    const response = await axios.get(`${JSON_DATA_URL}/${nZip}.json`);
    const { data } = response ?? {};
    CACHE[nZip] = data;
    parse(data, callback);
  } catch {
    callback(null);
  }
};

function checkInvalidZipcode(zipcode: string) {
  return !zipcode?.trim() || !POSTAL_CODE_PATTERN.test(zipcode);
}

function handleChangeAddress(form: FormInstance, zipcodeNamePath: NamePath) {
  if (form.getFieldError(zipcodeNamePath)[0] === messageZipcodeNotfound)
    form.setFields([{ name: zipcodeNamePath, errors: [] }]);
}

function handleShowAddress(
  form: FormInstance,
  zipcode: string,
  zipcodeNamePath: NamePath,
  addressNamePath: NamePath,
) {
  getAddressByPostalCode(zipcode, address => {
    form.setFields([
      {
        name: addressNamePath,
        ...(address
          ? {
              value: [
                address.prefecture,
                address.city,
                address.area,
                address.street,
              ]
                .filter(Boolean)
                .join(''),
              errors: [],
            }
          : {}),
      },
      {
        name: zipcodeNamePath,
        errors: address ? [] : [messageZipcodeNotfound],
      },
    ]);
  });
}

export {
  checkInvalidZipcode,
  getAddressByPostalCode,
  handleChangeAddress,
  handleShowAddress,
};
